'use strict';

var SchedulesFilterByMonthsFactory = function SchedulesFilterByMonthsFactory(DataFilter) {
  function SchedulesFilterByMonths() {
    DataFilter.call(this, ['market-dashboard', 'fim-dashboard'], 'year-and-month', 2);
  }
  SchedulesFilterByMonths.prototype = Object.create(DataFilter.prototype);
  SchedulesFilterByMonths.prototype.filter = function (data, range) {
    return DataFilter.prototype.filter(data, range, 'month');
  };
  return SchedulesFilterByMonths;
};
SchedulesFilterByMonthsFactory.$inject = ['DataFilterFactory'];
module.exports = SchedulesFilterByMonthsFactory;